import UserTypes from "./user.types";

export const updateUserPoints = updatePoints => ({
  type: UserTypes.UPDATE_USER_POINTS,
  updatePoints
});
